import React, { Component } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { compose, withState, withHandlers } from 'recompose';

import { getUser } from '../../../../redux/actions';
import { GET_USER } from '../graphql/index';

import Root from '../../components/root/Root';


const mapDispatchtoProps = (dispatch) => {
  return {
    getUser: (newUser) => {
      const user = newUser &&
        {
          email: newUser.email,
          name: newUser.name,
          token: newUser.token,
        };
      dispatch(getUser(user));
    },
  };
};


/* eslint-disable react/prop-types */
class Container extends Component {
  componentDidMount() {
    const query = this.props.location && this.props.location.query;
    const token = query && query.token;
    if (token) {
      this.props.login(token);
    }
  }

  render() {
    return <Root {...this.props} />;
  }
}

const withData = (props) => {
  const login = (token) => {
    if (!props.loading && !props.error) {
      props.toggleLoading(true); // toggle loading
      props.mutate({ variables: { token } }).then(({ data }) => {
        props.toggleLoading(false);               // toggle loading
        localStorage.token = token;               // update localStorage
        localStorage.userName = data.user.name;   // update localStorage
        localStorage.userEmail = data.user.email; // update localStorage
        props.getUser(data.user);                 // update store
        props.router.push('/dashboard');          // change route
      }).catch((error) => {
        console.log(error); // eslint-disable-line no-console
        delete localStorage.token;     // update localStorage
        delete localStorage.userName;  // update localStorage
        delete localStorage.userEmail; // update localStorage
        props.getUser(null);           // update store
        props.toggleError(true);
        props.toggleLoading(false);
      });
    }
  };

  return <Container {...props} login={login} />;
};
/* eslint-enable react/prop-types */

const enhance = compose(
  withState('loading', 'toggleLoading', false),
  withState('error', 'toggleError', false),
  withHandlers(
    {
      toggleLoading: props => (loading) => {
        props.toggleLoading(loading);
      },
      toggleError: props => (error) => {
        props.toggleError(error);
      },
    },
  ),
);

const RootContainer = enhance(withRouter(connect(null, mapDispatchtoProps)(withData)));

export default graphql(GET_USER)(RootContainer);



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/apollo/containers/RootContainer.js
 **/